<template>
  <div>
    <div v-if="!tooComplex">
      <highcharts :options="chartOptions"></highcharts>
    </div>
    <div v-if="tooComplex">
      <v-alert type="warning">Too many items to graph simultaneously. Reduce number of graphs below {{ maxGraphs}} using filters. Attempting to display {{ desiredGraphCount }} graphs</v-alert>
    </div>
    <div v-if="debug">
      <!-- <p>Values: {{ values }}</p> -->
      <p>Too complex: {{ tooComplex }}</p>
      <p>Group 1: {{ group1 }}</p>
      <p>Group 2: {{ group2 }}</p>
      <p>GroupForXAxis: {{ groupForXAxis }}</p>
      <p>groupForSeriesAccess: {{ groupForSeriesAccess }}</p>
      <p>xAxisKeys: {{ xAxisKeys }}</p>
      <p>xAxisTextLabels: {{ xAxisTextLabels }}</p>
      <p>seriesSetKeys: {{ seriesSetKeys }}</p>
      <p>seriesSetLabels: {{ seriesSetLabels }}</p>
      <p>Plotted: {{ plotted }}</p>
      <p>Percent scale: {{ percentscale }}</p>
      <p>Percent format: {{ percentformat }}</p>
      <p>Title Part 1 {{ titlepart1 }}</p>
      <p>Axis Label {{ axislabel }}</p>
      <p>Swap groups: {{ swapgroups }}</p>
      <p>Swapped: {{ groupsSwapped }}</p>
      <p>Graph Type {{ graphtype }}</p>
      <p>Series: {{ series }}</p>
      <!--<p>{{flatGroupedData}}</p>
      <p>{{values}}</p>-->
      <!-- <InsightReportRawTable
        title="Grouped Graph Data (Beringar Debug Only)"
        :rows="flatGroupedData"
      ></InsightReportRawTable> -->
    </div>
  </div>
</template>

<script>

import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import exportingInit from 'highcharts/modules/exporting'
// import stockInit from "highcharts/modules/stock";
import offlineExporting from 'highcharts/modules/offline-exporting'
import exportData from 'highcharts/modules/export-data'
import noDataToDisplay from 'highcharts/modules/no-data-to-display'
import reportUtil from '../../lib/reportUtil'
// import InsightReportRawTable from './../InsightReportRawTable'
import _ from 'lodash'
import dateUtil from '../../lib/dateUtil'
import beringarColourSets from '@/config/beringarColourSets'

// stockInit(Highcharts);
exportingInit(Highcharts)
offlineExporting(Highcharts)
exportData(Highcharts)
noDataToDisplay(Highcharts)

// eslint-disable-next-line no-unused-vars
let legandVerticalInside = {
  layout: 'vertical',
  backgroundColor: '#FFFFFF',
  align: 'left',
  verticalAlign: 'top',
  floating: true,
  x: 90,
  y: 45
}

// eslint-disable-next-line no-unused-vars
let legandDefault = {}

// eslint-disable-next-line no-unused-vars
let legandRight = {
  align: 'right'
}

// eslint-disable-next-line no-unused-vars
let legandRightProximate = {
  layout: 'proximate',
  align: 'right'
}

function dayOfWeekValueArrayToString (values) {
  try {
    return values.map(x => dateUtil.daysOfWeekDict[parseInt(x)].text)
  } catch {
    return values
  }
}

function substrValueArrayToString (values, start, end) {
  return values.map(x => x.substring(start, end))
}

function prettyFormatAxisValues (group, groupValues) {
  console.log('prettyFormatAxisValues')
  console.log('axis group', group)
  console.log('axis group values', groupValues)
  if (group === 'day_of_week') {
    return dayOfWeekValueArrayToString(groupValues)
  }
  if (group === 'ddmmyyyy') {
    return substrValueArrayToString(groupValues, 0, 10)
  }
  if (group === 'mmyyyy') {
    return substrValueArrayToString(groupValues, 0, 7)
  }
  if (group === 'date_local_month') {
    return substrValueArrayToString(groupValues, 0, 7)
  }
  if (group === 'yyyy') {
    return substrValueArrayToString(groupValues, 0, 4)
  }
  return groupValues
}

function simpleFormatter () {
  return this.value
}

function simpleFormatterPercent () {
  return this.value + '%'
}

function sortKeysByGroupType (keys, groupType) {
  console.log('Sort keys for group:', groupType, keys)
  let sorted = keys.slice().sort()
  console.log('Sort completed keys for group:', groupType, sorted)
  return sorted
  // sort(function(a, b){return a-b});
}

export default {
  name: 'InsightHighchartWithTwoDimensionGrouping',
  props: {
    group1: { type: String, required: true },
    group2: { type: String, required: true },
    plotted: { type: String, required: true },
    axislabel: { type: String, required: false, default: 'No Axis Value' },
    titlepart1: { type: String, required: false, default: 'No Title Value' },
    subtitle: { type: String, required: false, default: null },
    graphtype: { type: String, required: false, default: 'column' },
    swapgroups: { type: Boolean, required: false, default: false },
    percentscale: { type: Boolean, required: false, default: false },
    percentformat: { type: Boolean, required: false, default: false },
    debug: { type: Boolean, required: false, default: false },
    values: Array
  },
  components: {
    highcharts: Chart
    // InsightReportRawTable
  },
  computed: {
    groupsSwapped: function () {
      let result = false
      if (this.group2) {
        result = this.swapgroups
      }
      // console.log('groupsSwapped', result)
      return result
    },
    groupForXAxis: function () {
      let result = this.group1
      if (this.groupsSwapped) {
        result = this.group2
      }
      // console.log('groupForXAxis', result)
      return result
    },
    groupForSeriesAccess: function () {
      let result = this.group2
      if (this.groupsSwapped) {
        result = this.group1
      }
      // console.log('groupForSeriesAccess', result)
      return result
    },
    groupedData: function () {
      console.log('Start - Run grouping for groups: ' + this.groupForXAxis + ' ' + this.groupForSeriesAccess)
      let result = []
      result = reportUtil.groupX2AggregateManagedSpaceValuesReplaceNull(
        this.values, this.groupForSeriesAccess, this.groupForXAxis, '-Not Set-')
      reportUtil.addOccupanyAndUtililizationGroupX2(result)
      console.log('End - Run grouping for groups: ' + this.groupForXAxis + ' ' + this.groupForSeriesAccess)
      // console.log('Grouped Data', result)
      return result
    },
    tooComplex: function () {
      return this.seriesSetKeys.length > 50
    },
    desiredGraphCount: function () {
      return this.seriesSetKeys.length
    },
    series: function () {
      console.log('Insight highchart - compute series - start')
      let result = []

      if (this.tooComplex) {
        return result
      }

      for (let seriesSetKeyIndex in this.seriesSetKeys) {
        let seriesSetName = this.seriesSetKeys[seriesSetKeyIndex]
        // console.log('Build series - seriesSetKeyIndex', seriesSetKeyIndex, seriesSetName)
        let unsortedSeries = this.groupedData[seriesSetName]
        let data = []
        for (let xAxisKey of this.xAxisKeys) {
          let value = 0
          if (unsortedSeries) {
            let row = unsortedSeries[xAxisKey]
            if (row) {
              value = row[this.plotted] || 0
            }
          }
          value = value * (this.percentscale ? 100 : 1)
          value = Math.round(value * 10) / 10
          data.push(value)
        }
        let graphSeries = {
          data: data,
          animation: {
            duration: 0
          }
        }
        if (this.groupForSeriesAccess) {
          let seriesName = this.seriesSetLabels[seriesSetKeyIndex]
          graphSeries['name'] = seriesName
        } else {
          graphSeries['name'] = ''
        }
        result.push(graphSeries)
      }
      console.log('Insight highchart - compute series - end')
      return result
    },
    showLegand: function () {
      if (this.groupForSeriesAccess) return true
      return false
    },
    seriesSetKeys: function () {
      // console.log('Start - seriesSetKeys')
      let keys = Object.keys(this.groupedData)
      let sorted = sortKeysByGroupType(keys, this.groupForSeriesAccess)
      console.log('End - seriesSetKeys', sorted)
      return sorted
    },
    seriesSetLabels: function () {
      return prettyFormatAxisValues(this.groupForSeriesAccess, this.seriesSetKeys)
    },
    xAxisKeys: function () {
      // console.log('Start - xAxisKeys')
      let allKeys = []
      for (let outerKey in this.groupedData) {
        let keys = Object.keys(this.groupedData[outerKey])
        allKeys = allKeys.concat(keys)
      }
      let keys = _.uniq(allKeys)
      let sorted = sortKeysByGroupType(keys, this.groupForXAxis)
      console.log('End - xAxisKeys', sorted)
      return sorted
    },
    xAxisTextLabels: function () {
      return prettyFormatAxisValues(this.groupForXAxis, this.xAxisKeys)
    },
    flatGroupedData: function () {
      // console.log('Start - flatGroupedData')
      let result = []
      for (let outerKey in this.groupedData) {
        for (let innerKey in this.groupedData[outerKey]) {
          result.push(this.groupedData[outerKey][innerKey])
        }
      }
      // console.log('End - flatGroupedData')
      return result
    },
    chartOptions: function () {
      return {
        chart: {
          animation: false,
          type: this.graphtype,
          style: {
            fontFamily: 'NeutrifPro-Regular'
          }
        },
        colors: beringarColourSets.chart,
        title: {
          text: this.titlepart1 + ' By ' + _.startCase(this.groupForXAxis + ((this.groupForSeriesAccess) ? ' and ' + this.groupForSeriesAccess : ''))
        },
        subtitle: {
          text: this.subtitle
        },
        credits: {
          enabled: false
        },
        lang: {
          noData: 'No Data To Display'
        },
        noData: {
          style: {
            fontWeight: 'bold',
            fontSize: '20px',
            color: '#303030'
          }
        },
        exporting: {
          buttons: {
            contextButton: {
              menuItems: [
                'printChart',
                'separator',
                'downloadPNG',
                'downloadJPEG',
                'downloadPDF',
                'downloadSVG',
                'separator',
                'downloadCSV',
                'downloadXLS',
                'separator',
                'viewData'
              ]
            }
          },
          chartOptions: {
            credits: {
              enabled: true,
              text: 'Created With Beringar'
            }
            // plotOptions: {
            //   series: {
            //     dataLabels: {
            //       enabled: true
            //     }
            //   }
            // }
          }
        },
        xAxis: {
          categories: this.xAxisTextLabels,
          crosshair: true
        },
        yAxis: {
          min: 0,
          title: {
            text: this.axislabel
          },
          // plotLines: [{
          //   color: 'red',
          //   value: '45', // Insert your average here
          //   width: '1',
          //   zIndex: 2 // To not get stuck below the regular plot lines
          // }],
          labels: {
            formatter: this.percentformat ? simpleFormatterPercent : simpleFormatter
          }
        },
        // legend: legandRightProximate,
        legend: {
          enabled: this.showLegand,
          maxHeight: 80
        },
        series: this.series
      }
    }
  },
  data: () => {
    return {
      maxGraphs: 50
    }
  }
}
</script>

<style scoped>

</style>
